export const ADMIN_ROUTES = {
  ADMIN_CHECKLIST: "/user-guide/admin-checklist",
  ADMIN_OPERATIONAL: "/admin/operational",
  ADMIN_INTEGRATIONS: "/admin/integrations",
  ADMIN_SYNC_DIAGNOSTICS: "/admin/sync-diagnostics",
  ADMIN_AUTHZ: "/iam",
  ADMIN_AUTHZ_TENANTS: "/iam/tenants",
  ADMIN_AUTHZ_SERVICES: "/iam/services",
  ADMIN_AUTHZ_SERVICE_ITEMS: "/iam/service-items",
  ADMIN_AUTHZ_SYNC: "/iam/sync",
  ADMIN_AUTHZ_AUDIT: "/iam/audit",
  ADMIN_AUTHZ_SIMULATOR: "/iam/simulator",
  ADMIN_AUTHZ_ROLES: "/iam/roles",
  ADMIN_AUTHZ_USERS: "/iam/users",
  ADMIN_RULES: "/admin/rules",
  ADMIN_TEMPLATE_ROUTING_RULES: "/admin/template-routing-rules",
  ADMIN_LEDGER: "/admin/ledger",
} as const;

export type AdminRouteKey = keyof typeof ADMIN_ROUTES;
